define.alias("shared/utils/analytics/generate-cache-key", "settings/utils/analytics/generate-cach-key");